module.exports = "/../../dist/frontend/images/retromobile.webp?248fa3a43fd1559a14af4981f61d51e2";